import styled from 'styled-components';

export const MapContainer = styled.div`
  width: 100%;
  height: 300px;
  position: relative;

  .leaflet-pane {
    z-index: 1;
  }

  .leaflet-top,
  .leaflet-left,
  .leaflet-right,
  .leaflet-bottom {
    z-index: 2;
  }

  .marker-relative {
    position: relative;
  }

  .marker-pin img {
    max-width: none;
    max-height: none;
    width: auto;
    padding: 0;
  }

  .marker-pill {
    width: fit-content;
    min-height: fit-content;
    background-color: #b191ff;
    top: -10px;
    left: 60%;
    font-size: 12px;
    padding: 0 4px;
    color: ${({ theme }) => theme.white};
    border-radius: 5px;
    line-height: 21.6px;
    white-space: nowrap;
    max-width: 208px;
    overflow: hidden;
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
    font-weight: 600;
    position: absolute;
  }

  .marker-searched {
    background-color: ${({ theme }) => theme.green};
  }
`;

export const ExpandButton = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 2;
  padding: 8px;
  font-size: 15px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  border-radius: 5px;
  transition: background-color linear 150ms;
  color: ${({ theme }) => theme.white};
  user-select: none;
  gap: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
`;
